import { Booking } from "./booking.model";
import { dateToString, moneyToString, scrollToTop, setStepQS, Variables } from "./common";
import { RoomBookingStatusEnum } from "./room-booking.model";
import { Step2 } from "./step2";

/**
 * Using singleton design pattern
 */
export class Step3 {

    private static _instance: Step3;

    /**
     * The Singleton's constructor should always be private to prevent direct
     * construction calls with the `new` operator.
     */
    private constructor() {

        this.handleBackButton();

        this.handleSubmitButton();

    }



    /**
     * The static method that controls the access to the singleton instance.
     *
     * This implementation let you subclass the Singleton class while keeping
     * just one instance of each subclass around.
     */
    public static get instance(): Step3 {
        if (!Step3._instance) {
            Step3._instance = new Step3();
        }

        return Step3._instance;
    }



    private stepId = "bookingStep3";
    private submitDivId = "dvSubmit";
    private formId = "submitForm";
    private ignoreInEmailValue = "IgnoreThisFieldInEmail";

    /**
     * hide : hides step 3
     */
    public hide() {
        Variables.$(`#${this.stepId}`).removeClass("active");
    }

    /**
     * show : shows step 3
     */
    public show() {
        Variables.$(`#${this.stepId}`).addClass("active");
        scrollToTop(this.stepId);
        setStepQS('step3');
    }

    /**
     * clickBackButton
     */
    public clickBackButton() {
        this.hide();
        Step2.instance.show();
    }

    private handleBackButton = () => {
        Variables.$(`#${this.stepId} #btnBackToStep2`).click(() => {
            this.clickBackButton();
        });
    }

    private handleSubmitButton() {
        Variables.$(`#${this.stepId} #${this.submitDivId}`).click(() => {
            this.submitForm();
        });

        Variables.$(`#${this.stepId} form#${this.formId}`).on("beforeSubmit", () => {

            Variables.$(`#${this.stepId} #dvStep3TopMessage`).hide();
            Variables.$(`#${this.stepId} #step3BottomButtons`).hide();
            Variables.$(`#${this.stepId} #submitForm`).hide();

            Variables.$(`#${this.stepId} #${Variables.submittingDivId}`).show();

            // scrolling to the submitting div,because sometimes it was scrolling to the top of the page for some reason!
            setTimeout(() => {
                Variables.$("html, body").animate(
                    {
                        scrollTop:
                            Variables.$(`#${this.stepId} #${Variables.submittingDivId}`)
                                .offset().top - 100,
                    },
                    1
                );
            }, 1);
        });

        Variables.$(`#${this.stepId} form#${this.formId}`).on("afterSuccess", () => {
            Variables.$(`#${this.stepId} #${Variables.submittingDivId}`).hide();
            Variables.$(`#${Variables.availabilitiesDivId}`).show();

            // remove bookingStep=Step3 from the end of URL
            window.history.replaceState(null, '', window.location.pathname);
            //reEnableBackButton();
        });
        Variables.$(`#${this.stepId} form#${this.formId}`).on("afterError", () => {

            Variables.$(`#${this.stepId} #dvStep3TopMessage`).show();
            Variables.$(`#${this.stepId} #step3BottomButtons`).show();
            Variables.$(`#${this.stepId} #submitForm`).show();

            Variables.$(`#${this.stepId} #${Variables.submittingDivId}`).hide();
            Variables.$(`#${Variables.availabilitiesDivId}`).show();
        });

    }

    private booking: Booking

    /**
     * setBooking
     */
    public setBooking(booking: Booking) {
        this.booking = booking;

        Variables.$(`#hdChaletName`).val(this.booking.availability.name);
        Variables.$(`#hdArrivalDate`).val(dateToString(this.booking.availability.arrivalDate, true));
        Variables.$(`#hdDepartureDate`).val(dateToString(this.booking.availability.departureDate, true));
        Variables.$(`#hdDuration`).val(`${this.booking.availability.duration} Nights`);
        Variables.$(`#hdTotalPrice`).val(moneyToString(this.booking.finalPrice, true));

        const $annexInput = Variables.$("input#hdAnnex");
        if (this.booking.annexRooms?.price) {
            $annexInput.val(`€${this.booking.annexRooms.price} for ${this.booking.annexRooms.roomsNumber} annex bedroom(s) included.`)
        } else {
            $annexInput.val(this.ignoreInEmailValue);
        }

        const $roomsDescPlaceHolder = Variables.$("#dvRoomsDescriptionsForEmail");
        $roomsDescPlaceHolder.html();

        const $paxInput = Variables.$("input#hdPax");
        const $inputsShowingIfPartialRooming = Variables.$("input[data-conditional-for-email='HasRooming']");
        if (!this.booking.roomsBooking?.length) { // is not partial booking

             if (this.booking.availability.minPax !== this.booking.availability.maxPax) { 
                $paxInput.val(`${this.booking.availability.minPax}-${this.booking.availability.maxPax}`);
            } else {
                $paxInput.val(`${this.booking.availability.maxPax}`);
            }

            $inputsShowingIfPartialRooming.val(this.ignoreInEmailValue);

        } else {
            // Since we include details of PAX for each room, we do not show Pax No. here
            $paxInput.val(this.ignoreInEmailValue);

            $inputsShowingIfPartialRooming.each((index, element) => {
                const $input = Variables.$(element);
                $input.val($input.data('default-value'));
            });

            $roomsDescPlaceHolder.append(Variables.$(`<input type="hidden" name="Price Per Person" value="${moneyToString(this.booking.availability.currentPrice)}" />`));
            // for each room, create a hidden input to be included in email and add it to place holder Div
            for (let i = 0; i < this.booking.roomsBooking.length; i++) {
                const roomBooking = this.booking.roomsBooking[i];
                if (roomBooking.status !== RoomBookingStatusEnum.Selected) {
                    continue;
                }

                let roomText = `${moneyToString(roomBooking.calculatedPrice, true)}, for `;
                if (roomBooking.adultsNumber) {
                    roomText += `${roomBooking.adultsNumber} adult(s), `;
                }
                if (roomBooking.childrenNumber) {
                    roomText += `${roomBooking.childrenNumber} child(ren), `;
                }
                if (roomBooking.babiesNumber) {
                    roomText += `${roomBooking.babiesNumber} baby(ies), `;
                }

                if (roomBooking.adultsNumber + roomBooking.childrenNumber === 1 && roomBooking.singleRoomSupplementFactor) {
                    roomText += `${(roomBooking.singleRoomSupplementFactor - 1) * 100}% single occupancy rate increase applied, `;
                }

                if (roomBooking.childrenNumber) {
                    roomText += `${moneyToString(roomBooking.childDiscount)} discount per child applied, `;
                }

                if (roomBooking.babiesNumber) {
                    roomText += `${moneyToString(roomBooking.babyPrice)} per baby applied, `;
                }

                if (roomBooking.extraPriceForThisRoom) {
                    roomText += `${moneyToString(roomBooking.extraPriceForThisRoom)} premium bedroom rate applied`;
                }

                if (roomBooking.aptDiscountPerPerson) {
                    roomText += `${moneyToString(roomBooking.aptDiscountPerPerson, true)} per person discount applied`;
                }


                const $newRoom = Variables.$(`<input type="hidden" name="${Step2.instance.findRoom(i, this.booking.availability.name).name}" value="${roomText}" />`);

                $roomsDescPlaceHolder.append($newRoom);
            }
        }


    }

    public submitButtonPoppingState = false;


    private submitForm() {
        this.submitButtonPoppingState = true;

        Variables.$(`form#${this.formId}`).submit();
    }






}
